import { AxiosError } from 'axios'

export const isUnauthorizedError = (error: AxiosError) => error.response?.status === 401

export const isForbiddenError = (error: AxiosError) => error.response?.status === 403

export const ERRO_MAP_ENUM = {
  ResourceNotFound: 'resource_not_found',
}

export type OkamiHttpGatewayErrorShapeDefault = { message: string }

export type OkamiHttpGatewayErrorShapeWithDetails = {
  code: (typeof ERRO_MAP_ENUM)[keyof typeof ERRO_MAP_ENUM]
  message: string
  cause: keyof typeof ERRO_MAP_ENUM
}

export type OkamiHttpGatewayErrorShape =
  | OkamiHttpGatewayErrorShapeDefault
  | OkamiHttpGatewayErrorShapeWithDetails

export const isOkamiHttpGatewayErrorDetails = (
  error: any,
): error is OkamiHttpGatewayErrorShapeWithDetails => {
  return typeof error === 'object' && 'code' in error && 'message' in error && 'cause' in error
}

export class OkamiHttpGatewayError extends AxiosError<OkamiHttpGatewayErrorShape> {
  isUnauthorizedError() {
    return isUnauthorizedError(this)
  }

  isForbiddenError() {
    return isForbiddenError(this)
  }

  isResourceNotFoundError() {
    return (
      isOkamiHttpGatewayErrorDetails(this.response?.data) &&
      this.response.data.code === ERRO_MAP_ENUM.ResourceNotFound
    )
  }

  isUserAlreadyExistsError() {
    return this.response?.data?.message === 'User already exists'
  }
}
